import { convertFromFirestoreTimestamp } from 'utils/firestore-timestamp';
import { DEVICE_STATUS } from 'utils/constants/statuses';

export const statusColor = status => {
    switch (status) {
        case 'active':
            return 'success';
        case 'pending':
            return 'info';
        case 'suspended':
            return 'warning';
        case 'revoked':
            return 'default';
        default:
            return 'default';
    }
};

export const grantRowStatus = status => {
    switch (status) {
        case 'active':
            return DEVICE_STATUS.ENABLED;
        case 'suspended':
            return DEVICE_STATUS.DISABLED;
        case 'pending':
            return DEVICE_STATUS.AWAITING_APPROVAL;
        case 'revoked':
            return DEVICE_STATUS.REVOKED;
        default:
            return status;
    }
};

export const formatDate = timestamp => {
    if (
        !timestamp ||
        (typeof timestamp.seconds !== 'number' && typeof timestamp._seconds !== 'number')
    ) {
        return '—';
    }
    return convertFromFirestoreTimestamp(timestamp);
};

export const errorMessageFrom = error => {
    const message = error?.message ?? error;
    return Array.isArray(message) ? message.join(', ') : String(message);
};
